import { LogOut } from 'lucide-react';
import { InitialsAvatar } from '@/components/InitialsAvatar';
import { ThemeToggle } from '@/components/ThemeToggle';
import { Button } from '@/components/ui/button';
import { useSignOut } from '@/hooks/use-sign-out';
import type { Me } from '@/types/me';
import { NavItemLink } from './NavGroups';
import { NAV_ITEMS, type NavItem } from './nav-items';

function findSettingsItem(): NavItem {
  const item = NAV_ITEMS.find((i) => i.key === 'settings');
  if (!item) throw new Error('NAV_ITEMS has no settings item');
  return item;
}

const SETTINGS_ITEM = findSettingsItem();

/** Sidebar/drawer footer: theme control, Settings link and the user row with Sign out. */
export function SidebarFooter({ me, onNavigate }: { me: Me; onNavigate?: () => void }): JSX.Element {
  const signOut = useSignOut();
  return (
    <div className="space-y-0.5 border-t border-border p-3">
      <div className="px-1 pb-2">
        <ThemeToggle fullWidth iconOnly />
      </div>
      <NavItemLink item={SETTINGS_ITEM} onNavigate={onNavigate} />
      <div className="flex items-center gap-3 rounded-lg px-3 py-2 text-sm">
        <InitialsAvatar name={me.name} email={me.email} className="h-6 w-6 text-[10px]" />
        <div className="min-w-0 flex-1">
          <p className="truncate text-foreground" title={me.email}>
            {me.name}
          </p>
          <p className="text-xs text-muted-foreground">{me.role === 'admin' ? 'Admin' : 'User'}</p>
        </div>
        <Button variant="ghost" size="icon-sm" aria-label="Sign out" onClick={() => void signOut()}>
          <LogOut />
        </Button>
      </div>
    </div>
  );
}
